import { Uuid } from "@/domains/global/identifiers";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelData, SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { makeObservable, observable } from "mobx";

export class AssistantSyncModelObservable<
  ModelData extends SyncModelData,
> extends BaseSyncModel<ModelData> {
  public modelKind!: SyncModelKind;

  constructor({
    id,
    data,
    store,
    modelKind,
  }: {
    id: Uuid;
    data: SyncUpdateValue<ModelData>;
    modelKind: SyncModelKind;
  } & WithAppStore) {
    super({ id, data, store });
    this.modelKind = modelKind;

    makeObservable(this, {
      modelKind: observable,
    });
  }
}
